import NetworkService from "./NetworkService";

export default class PayoutAdminService extends NetworkService {
  constructor() {
    super();
    this.endpoints.adminPayouts = "api/admin/payouts";
  }

  show(id) {
    return this.get(`${this.endpoints.adminPayouts}/${id}`);
  }
}
